import { Component, OnInit, Inject, Input, OnDestroy } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';

import {
    creditCardNumberValidator,
    creditCardCVVCIDValidator,
    expiryDateInSingleFieldValidator,
} from '@shared/core/validators/credit-cards.shared.validator';
import * as Utils from '@shared/core/utils';
import * as Tokens from '@shared/core/tokens';
import { Controllers } from '@shared/core/controllers';

import { FormTypesComponent } from '../form-types.shared.component';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-form-for-payment-method',
    templateUrl: './form-for-payment-method.shared.component.html',
    styleUrls: ['./form-for-payment-method.shared.component.scss']
})
export class FormForPaymentMethodComponent extends FormTypesComponent implements OnInit, OnDestroy {
    @Input() public allowCancel: boolean = false;

    public isMakingRequests$: Observable<boolean>;
    public canCancelForm$: Observable<boolean>;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public formBuilder: FormBuilder,
        public controllers: Controllers,
    ) {
        super(config, formBuilder);
        this.formName = 'payment-method';

        this.compact = false;
        this.labelSubmit = 'Add payment method';
    }

    ngOnInit(): void {

        this.formControl = this.formBuilder.group({
            cardNumber: [
                { value: '', disabled: false },
                {
                    validators: Validators.compose([
                        Validators.required,
                        Validators.minLength(15),
                        Validators.maxLength(16),
                        creditCardNumberValidator(true),
                    ]),
                },
            ],
            expiryDate: [
                { value: '', disabled: false },
                {
                    validators: Validators.compose([
                        Validators.required,
                        expiryDateInSingleFieldValidator()
                    ]),
                },
            ],
            cvv: [
                { value: '', disabled: false },
                {
                    validators: Validators.compose([
                        Validators.required,
                    ]),
                    asyncValidators: Validators.composeAsync([

                        creditCardCVVCIDValidator('cardNumber'),
                    ])

                },
            ],
            saveCard: [
                { value: this.guest === false, disabled: false }
            ],
            isDefaultPaymentMethod: [
                { value: this.guest === false, disabled: false }
            ],
        });

        this.isMakingRequests$ = this.controllers.creditCards.isMakingRequests$();
        this.canCancelForm$ = this.controllers.creditCards.canCancelAddingNewCardsForm$();
    }

    ngOnDestroy(): void {
        this.controllers.creditCards.resetCreditCardErrors();
    }

    private _submit(): void {
        this.controllers.creditCards.addCreditCard(Utils.Forms.extractValues(this.formControl) as OLO.CreditCards.ICreditCardDetails);
    }

    public handleFormSubmit($event: Event): void {
        this.onFormSubmit.emit({
            event: $event,
            form: this.formControl,
        });

        if (this.delay !== null) {
            setTimeout(this._submit.bind(this), this.delay);

            return;
        }

        return this._submit();
    }

    public handleFormCancel($event: Event): void {
        this.controllers.creditCards.toggleCreditCardFormVisibilityWithCleanUp(false);
    }

    public handleExpDateChange($event: OLO.Components.IPrevNextEvent): void {
        /* Add / on the fly */
        const nextVal: string = `${$event.next}`;
        const prevVal: string = `${$event.previous}`;

        if (nextVal && nextVal.length > prevVal.length && nextVal.length === 2) {
            this.formControl.controls.expiryDate.setValue(`${nextVal}/`);
        }

    }
}
